export const C537 = {
    wizard: {
        insuranceCoverage: {
            title: 'Protection Coverage',
            noInsuranceSelected: 'No Protection Selected',
        },
    },
};
